
const AboutDescription = ({title, description, descriptionExtended}) => {
  return (
    <div className="container">
      <div
        className="row g-5 align-items-center content-wrapper"
      >
        <div className="col-xxl-3 col-xl-3 col-lg-6">
          <div className="inner">
            <div className="content text-start">
              <h2 className="title color-white mb--0">{title}</h2>
            </div>
          </div>
        </div>
        <div className="col-xxl-8 col-xl-8 col-lg-10">
          <div className="inner-content text-start">
            <p className="color-white">{description}</p>
            <p className="color-white">{descriptionExtended}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDescription;
